import styles from './Articles.module.css';
import React from 'react';

const getMonthText = (month) => {
  return [
    'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN',
    'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
  ][month];
};

const renderArticle = (article) => {
  if (!article || !article.fieldData) return null;

  const dateObj = new Date(article.createdOn || article.createdOn);
  const year = dateObj.getFullYear();
  const month = getMonthText(dateObj.getMonth());
  const day = dateObj.getDate();

  const title = article.fieldData.name || "Untitled";
  const imageUrl = article.fieldData['thumbnail-image']?.url || null;
  const url = "https://www.blackbullbiochar.com/articles/" + article.fieldData.slug;
  return (
    <div className={styles.articleRow} key={article.id} onClick={() => window.open(url, "_blank")}>
      {imageUrl && (
        <img src={imageUrl} alt={title} className={styles.articleImage} />
      )}
      <div className={styles.articleInfo}>
        <div className={styles.articleDate}>{`${day} ${month} ${year}`}</div>
        <div className={styles.articleTitle}>{title}</div>
      </div>
    </div>
  );
};

const Articles = ({ articles }) => {
  return (
    <div className={styles.articlesContainer}>
      <div className={styles.rowsContainer}>
        {articles?.slice(0, 5).map(renderArticle)}
      </div>
    </div>
  );
};

export default React.memo(Articles);